import { LoaderFunction } from "react-router-dom";
import {
  ContentDecisionResponse,
  OptDecision,
  updateContentDecision,
} from "common/api/decimal/methods/course.ts";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";
import usePromiseFetcher from "common/core-ui/usePromiseFetcher.ts";

export const updateContentDecisionAction: LoaderFunction = async ({
  request,
}): Promise<DecimalResult<ContentDecisionResponse>> => {
  const formData = await request.formData();
  const courseId = formData.get("courseId") as string | number;
  const verbaLicenseId = formData.get("verbaLicenseId") as string;
  const decision = formData.get("decision") as OptDecision;
  const reasonId = formData.get("reasonId") as string;
  const contentDecision = { decision, reasonId };
  return updateContentDecision(courseId, verbaLicenseId, contentDecision);
};

export function useContentDecisionFetcher() {
  return usePromiseFetcher<DecimalResult<ContentDecisionResponse>>();
}
